<!-- 固定データ確認 -->
<is-igx-mapping
    *ngIf="!loading"
    [environmentKey]="environmentKey"
    [mappingData]="mappingData"
    [leftWbsData]="StaticLeftWbsData"
    [rightWbsData]="StaticRightWbsData"
    [mappingDataHub]="mappingDataHub"
>
</is-igx-mapping>

<pre>
    <textarea [(ngModel)]="mappingDataString" style="width: 90%; height: 300px"></textarea>
    <button (click)="reflectMappingData()">反映</button> 
 </pre>
